import React from "react";
import { Redirect } from "react-router-dom";
import * as paths from "routes/paths";

// MAX-4419: three retired pages send old bookmarks to IDX. /settings/optima-express (the WordPress
// Plugin page) only held the registration key, now in IDX's Connection block. /settings/version
// (Version & Platform) split into IDX and Display, and IDX is where its version and platform went.
// /settings/pages (SEO Pages) is now IDX's IDX Pages table.
export const SettingsIdxRedirect: React.FC = () => (
	<Redirect to={paths.settingsIdx} />
);
